import React, { FC, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { ISfWallet } from '@sparling/financial-common'
import { useParams } from 'react-router'

import { Modal } from '../../../../components/Modal'
// import { GreenButton } from '../../../../components/Buttons/GreenButton'
import { IDataItem, TableComponent } from '../../../../components/Table'
// import { icons } from '../../../../constants/icons'
import { columns, modalColumns } from './WalletsList'
import {
  assignSfWalletToUserRequest,
  getAssignedWalletsByUserRequest,
  getSfWalletsRequest,
  unassignSfWalletFromUserRequest,
} from '../../../../store/actions'
import {
  assignedWalletsIsLoading,
  getAssignedWalletIdsByUser,
  getAssignedWalletsByUser,
  getSfWalletsData,
  sfWalletsIsLoading,
} from '../../../../store/selectors'
import { Loader } from '../../../../components/Loader'
import { UserSparlingAccountModal } from '../UserSparlingAccountModal'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    height: '100%',
  },
  titleWrap: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const Wallets: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const { clientId: idSf } = useParams<{ clientId: string }>()
  const dispatch = useDispatch()
  const isLoading = useSelector(assignedWalletsIsLoading)
  const assignedIds = useSelector(getAssignedWalletIdsByUser)
  const { items: assignedWalletsData, meta: params } = useSelector(getAssignedWalletsByUser)
  const isLoadingWallets = useSelector(sfWalletsIsLoading)
  const { items: wallets, meta } = useSelector(getSfWalletsData)
  const [isOpenWalletModal, setOpenWalletModal] = useState<boolean>(false)
  const [isOpenUnassignModal, setOpenUnassignModal] = useState<boolean>(false)
  const [idToUnassign, setIdToUnassign] = useState<number | null>(null)

  const loadSfBankAccounts = useCallback(
    (page: number) => {
      if (idSf) {
        dispatch(getSfWalletsRequest({ excludes: assignedIds, page, limit: 10 }))
      }
    },
    [dispatch, idSf, assignedIds],
  )

  const loadAssignedWallets = useCallback(
    (page: number) => {
      if (idSf) {
        dispatch(getAssignedWalletsByUserRequest({ idSf, page, count: 10 }))
      }
    },
    [dispatch, idSf],
  )

  const unassignSfWalletFromUserHandle = useCallback(() => {
    if (idToUnassign && idSf) {
      dispatch(unassignSfWalletFromUserRequest({ walletIds: [idToUnassign], userIdSf: idSf }))
      setOpenUnassignModal(false)
      setIdToUnassign(null)
    }
  }, [dispatch, idToUnassign, idSf])

  const openUnassignModalHandle = useCallback((id: number) => {
    setIdToUnassign(id)
    setOpenUnassignModal(true)
  }, [])

  // const openWalletModalHandle = useCallback(() => {
  //   dispatch(getSfWalletsRequest({ excludes: assignedIds, page: 1, limit: 10 }))
  //   setOpenWalletModal(true)
  // }, [dispatch, assignedIds])

  const closeWalletModalHandle = useCallback(() => setOpenWalletModal(false), [])
  const closeUnassignModalHandle = useCallback(() => setOpenUnassignModal(false), [])

  const infoHandle = useCallback(() => history.push('/finance?accounts'), [history])

  const submitSelectedWallets = useCallback(
    (walletIds: number[]) => {
      if (idSf) {
        dispatch(assignSfWalletToUserRequest({ walletIds, userIdSf: idSf }))
        closeWalletModalHandle()
      }
    },
    [dispatch, idSf, closeWalletModalHandle],
  )

  if (isLoading) {
    return <Loader />
  }
  return (
    <>
      <Grid container className={classes.container}>
        <Grid container className={classes.titleWrap}>
          <Typography variant={'h6'}>Wallets</Typography>

          {/*  <GreenButton width={140} prefix={icons.ADD} ml={8} text={'Add Wallet'} onClick={openWalletModalHandle} />  */}
        </Grid>

        <Grid container className={classes.table}>
          <TableComponent
            columns={columns}
            data={assignedWalletsData as IDataItem<ISfWallet>[]}
            isShowRemoveIcon={true}
            isShowEditIcon={false}
            isShowInfoIcon={true}
            onInfo={infoHandle}
            onRemove={openUnassignModalHandle}
            loading={isLoading}
            loadData={loadAssignedWallets}
            params={params}
          />
        </Grid>
      </Grid>
      {isOpenWalletModal && (
        <UserSparlingAccountModal
          isOpen={isOpenWalletModal}
          modalClose={closeWalletModalHandle}
          title={'Add Wallet'}
          columns={modalColumns}
          data={wallets as IDataItem<ISfWallet>[]}
          meta={meta}
          loading={isLoadingWallets}
          loadingFunc={loadSfBankAccounts}
          assignHandle={submitSelectedWallets}
          width={860}
        />
      )}
      {isOpenUnassignModal && (
        <Modal
          title={'Unassigning Wallet'}
          isOpen={isOpenUnassignModal}
          modalClose={closeUnassignModalHandle}
          submitTitle={'Unassign'}
          onSubmit={unassignSfWalletFromUserHandle}
        >
          Are you sure you would like to unassign a wallet: {idToUnassign}?
        </Modal>
      )}
    </>
  )
}
